export var contentTypes = {
  AUDIOS: 'audios',
  IMAGES: 'images',
  LOCALIZATIONS: 'localizations',
  TEXT: 'text',
  HTML_TEXT: 'htmlText',
  VIDEOS: 'videos'
};

export var activityTypes = {
  READ_ALOUD: 'ReadAloud',
  CONVERSATION: 'Dialogue',
  OBJECTIVES: 'objectives',
  SUMMARY: 'summary'
};

export var stepTypes = {
  CARD: 'card',
  CLOZE: 'cloze',
  DOCUMENT: 'document',
  EXTENDED_SPEAKING: 'extended_speaking',
  EXTENDED_WRITING: 'extended_writing',
  MATCHING: 'matching',
  MULTIPLE_CHOICE: 'multipleChoice',
  PHONEME: 'phoneme',
  SEQUENCING: 'sequencing',
  WRITING: 'writing'
};

export var inputTypes = {
  SELECT: 'select',
  SPEAKING: 'speaking',
  TYPING: 'typing'
};